const request = {
    invalid_input: 'Nieprawidłowe dane wejściowe. {{details}}',
    general: 'Wystąpił błąd żądania.',
};
export default request;
